import React, { Component } from 'react'

import { DispatchersBox } from '../../../common/colored_box'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

class UsersListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick(this.props.data.id)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete(this.props.data.id)
    }

    render = () => {
        const classNames = ['row-selectable']
        if (this.props.data.deleted_at) {
            classNames.push('is-deleted')
        }

        return (
        <tr onClick={this.handleClick} className={classNames.join(' ')}>
            <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                <td className="w-60 table-buttons">
                    <PermissionsCheck has={[PERMS.UPDATE]}>
                        <button className="far fa-pencil text-gray m-r-xxs"/>
                    </PermissionsCheck>
                    {!this.props.data.deleted_at && (
                        <PermissionsCheck has={[PERMS.DELETE]}>
                            <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                        </PermissionsCheck>
                    )}
                </td>
            </PermissionsCheck>
            <td className="w-max wm-300">
                <DispatchersBox dispatcher={this.props.data}>{this.props.data.getFullName()}</DispatchersBox>
            </td>
            <td className="w-400">{this.props.data.email}</td>
            <td className="w-200">{this.props.data.phone}</td>
            <td className="w-200">{this.props.role && this.props.role.name}</td>
        </tr>)
    }
}

export default UsersListRow
